import React from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { Currency } from "@app/types/currencies";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Table } from "./components/Table";

type Rates = {
  direct: number;
  reverse: number;
};

type Props = {
  baseCurrency: Currency;
  convertCurrency: Currency;
  rates: Rates;
  title?: string;
};

export const AmountTables: React.FC<Props> = ({
  baseCurrency,
  convertCurrency,
  rates,
  title,
}) => (
  <Fade
    duration={DEFAULT_FADE_DURATION}
    triggerOnce
    className={classNames(
      "mt-20 px-5",
      "lg:mt-25 lg:px-16",
      "xl:mt-40 xl:px-24",
    )}
  >
    <div className={classNames("xl:mx-auto xl:max-w-container")}>
      {title ? (
        <h4
          className={classNames(
            "mb-10 text-medium text-primary-content",
            "md:mb-15 md:text-large",
            "xl:text-xx-large",
          )}
        >
          {title}
        </h4>
      ) : null}
      <div
        className={classNames(
          "flex flex-col gap-10",
          "md:flex-row",
          "lg:gap-13",
        )}
      >
        <Table
          baseCurrency={baseCurrency}
          convertCurrency={convertCurrency}
          rate={rates.direct}
        />
        <Table
          baseCurrency={convertCurrency}
          convertCurrency={baseCurrency}
          rate={rates.reverse}
        />
      </div>
    </div>
  </Fade>
);
